import axios from "@/http"

export function listViewClub(param){
  return axios({
    method:"GET",
    url: '/api/v1/extra/lecturehall/speechs',
    params:param
  })
}
export function deleteLecturehallSpeech(id) {
  return axios({
    url: '/api/v1/extra/lecturehall/speechs/' + id,
    method: 'delete'
  })
}
export function fetchLecturehallSpeech(id) {
  return axios({
    url: '/api/v1/extra/lecturehall/speechs/'+ id,
    method: 'get',
    params:{ id, preload: true },
  })
}

export function createLecturehallSpeech(data) {
  return axios({
    url: '/api/v1/extra/lecturehall/speechs',
    method: 'post',
    data
  })
}

export function updateLecturehallSpeech(data) {
  return axios({
    url: '/api/v1/extra/lecturehall/speechs/'+ data.id,
    method: 'put',
    params: data.where?{where: data.where}: undefined,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/axj-information/axj-information-view-club.js